import styled from 'styled-components'
import { DESCRIPTION_STYLED_PROPS } from './interfaces'

export const DescriptionBox = styled.article`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`
export const TextBox = styled.div`
  margin-left: 10px;
  text-transform: none;
  p {
    text-transform: none;
    margin: 8px 0;
    font-family: 'GT America, regularN';
  }
`
export const Icon = styled.div<DESCRIPTION_STYLED_PROPS>`
  min-width: ${({ width }) => width};
  min-height: ${({ height }) => height};
  background: ${({ background }) => background};
  border: solid 3px
    ${({ background, borderColor }) => borderColor || background};
  border-radius: 38px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ size }) => size};
  color: ${({ textColor }) => textColor};
  margin-left: 1px;
  svg {
    width: 24px;
    g {
      stroke: ${({ textColor }) => textColor};
    }
  }
`
